import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GlobalProvider } from "./Context/GlobalContext";
import OrderSoundOverlay from "./Components/common/OrderSoundOverlay";
import { BrowserRouter } from "react-router-dom"; 

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <GlobalProvider>
      {/* <OrderSoundOverlay /> */}
      <App />
    </GlobalProvider>
  </BrowserRouter>
  // </React.StrictMode>
);